module.exports = __webpack_public_path__ + "fonts/Kinetika-BlackItalic.04be6d24.ttf";